import React, {useEffect, useState} from "react";
import Button from "../../components/v2/Button";
import StepperCar from "../../components/v2/StepperCar";
import Input from "../../components/v2/Input";
import useValetStore from "./hooks/useValetStore";
import Alert, {ERROR, SUCCESS} from "../../components/v2/Alert";
import {ValetSteps} from "./constants/ValetSteps";
import Swal from "sweetalert2";
import {useTranslation} from "react-i18next";
import {GTMTriggers} from "../../constants/GTMTriggers";

export default function ValetAccountCreated({}) {

    //!\ Attention il peut arriver ici n'importe quand, suffit qu'il ait cliqué sur le lien de confirmation

    const [password, setPassword] = useState('');
    const [isError, setIsError] = useState(false);
    const [message, setMessage] = useState(null);

    const formRef = React.useRef();

    const {
        callPost,
        setStep,
    } = useValetStore();

    const {t} = useTranslation('common');

    useEffect(() => {
        if (password == "") {
            setIsError(true);
            setMessage(null);
            return;
        }

        let errors = checkPassword();
        if (errors.length > 0) {
            setIsError(true);
            setMessage(t('valet.account.invalid_password') + errors.join(", "));
        } else {
            setIsError(false);
            setMessage(t('valet.account.good_password'))
        }
    }, [password]);

    const nextClickedHandler = (e) => {
        if (!formRef.current.reportValidity()) {
            return;
        }
        callPost('set_password', {password}, (data) => {
            window.dataLayer.push({event: GTMTriggers.ACCOUNT_CREATED});
            setStep(ValetSteps.YOUR_VEHICLE);
        }, (failResultData) => {
            Swal.fire({
                text: failResultData.message,
                icon: 'error',
            });
        });
    }

    const checkPassword = () => {
        const errors = [];
        if (password.length < 10) {
            errors.push(t('valet.account.password_too_short'));
        }
        if (!/[A-Z]/.test(password)) {
            errors.push(t('valet.account.password_capital'));
        }
        if (!/[0-9]/.test(password)) {
            errors.push(t('valet.account.password_digit'));
        }
        return errors;
    }

    return <div className="h-full flex flex-col p-4 gap-4">
        <StepperCar value={40}/>
        <div className="text-white text-[30px] font-bold">
            {t('valet.account.account_activated')}
        </div>
        {t('valet.account.password_explain')}
        <br/><br/>
        {t('valet.account.password_rules')}
        <form ref={formRef}>
            <Input id="password" label={t('valet.account.password_label')}
                   placeholder={t('valet.account.password_example')}
                   value={password}
                   type={'password'}
                   required={true}
                   onChange={(e) => setPassword(e)}
            />
        </form>
        {message ?
            <Alert type={isError ? ERROR : SUCCESS}
                // label="Mot de passe invalide"
                   text={message}
            />
            : null}
        <div className="grow">
        </div>
        <Button disabled={isError} text={t('valet.account.resume_order')} clickHandler={nextClickedHandler}/>
    </div>
}